// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "locationsBox", "secondArrow" ]

  enlargeLocations() {
    this.locationsBoxTarget.classList.toggle('hidden');
    if (this.secondArrowTarget.classList.contains('rotate90')) {
      this.secondArrowTarget.classList.add('rotate-90')
      this.secondArrowTarget.classList.remove('rotate90')
    } else {
      this.secondArrowTarget.classList.add('rotate90')
      this.secondArrowTarget.classList.remove('rotate-90')
    }
  }
}
